import { Transition } from "history";
import { ReportSummaryItemApi } from "../api/Reports";
import { isNavigatingWithinReportScope } from "./reportNavigationUnlock";

interface ReportLocationState {
  stepDone: boolean;
}

/** Unlock guard for report auxiliary views (logs, debug) when leaving the report. */
const ReportAuxiliaryUnlockHook = (
  tx: Transition,
  isReadOnly: boolean,
  isLockedByOther: boolean,
  report: ReportSummaryItemApi | undefined,
  id: string | undefined,
  performUnlock: (
    workflowRunUUID: string,
    title: string,
    message: string,
    afterSuccess: () => void,
    positiveAction?: boolean,
    forceUnlock?: boolean,
    bypassUnlockPermission?: boolean
  ) => void,
  isUnlockError: boolean,
  isReportLoading: boolean,
  isActorIdentityPending: boolean,
  fallbackWorkflowRunUuid: string | undefined
) => {
  if (isNavigatingWithinReportScope(tx.location.pathname, id)) {
    tx.retry();
    return;
  }

  if (isUnlockError) {
    tx.retry();
    return;
  }

  if (isReadOnly || isLockedByOther) {
    tx.retry();
    return;
  }

  const workflowRunUuid = report?.workflow_run_uuid ?? fallbackWorkflowRunUuid;

  if (isActorIdentityPending) {
    return;
  }

  // Defer while summary load when we still lack an unlock target.
  if (!workflowRunUuid && isReportLoading) {
    return;
  }

  if (!workflowRunUuid) {
    tx.retry();
    return;
  }

  const redirectState = (tx.location.state as ReportLocationState) ?? null;
  if (redirectState?.stepDone) {
    performUnlock(
      workflowRunUuid,
      "",
      "",
      () => {
        tx.retry();
      },
      true,
      true,
      true
    );
    return;
  }

  const title = "Exit report?";
  const message =
    "By doing this you will exit the report and return to Reports.";

  performUnlock(
    workflowRunUuid,
    title,
    message,
    () => {
      tx.retry();
    },
    false,
    false,
    true
  );
};

export default ReportAuxiliaryUnlockHook;
